export const kwToPs = (powerInKw: number) => {
    return Math.round(powerInKw * 1.35962);
  };
  